/*eslint-disable*/export const messages=JSON.parse("{\"icon.title.error\":[\"Oktagon med utropstecken\"]}");